import React, { useState, useEffect, useRef } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";
import axios from 'axios';
import PublishKeyModal from "./PublishKey"
// JSON Editor Modal Component
const JsonEditorModal = ({ show, onClose, item, onSave }) => {
  const [jsonData, setJsonData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {

    if (item && item.json) {
      try {
        const parsed = JSON.parse(item.json);
        // Convert to array of key-value pairs
        const pairs = Object.entries(parsed).map(([key, value]) => ({ key, value: JSON.stringify(value) }));
        setJsonData(pairs);
        setError("");
      } catch (err) {
        setJsonData([]);
        setError("Invalid JSON format. Starting with empty object.");
      }
    } else {
      setJsonData([]);
    }
  }, [item]);

  const handleKeyChange = (index, newKey) => {
    const newData = [...jsonData];
    newData[index].key = newKey;
    setJsonData(newData);
  };

  const handleValueChange = (index, newValue) => {
    const newData = [...jsonData];
    newData[index].value = newValue;
    setJsonData(newData);
  };

  const addRow = () => {
    setJsonData([...jsonData, { key: "", value: "" }]);
  };

  const removeRow = (index) => {
    const newData = [...jsonData];
    newData.splice(index, 1);
    setJsonData(newData);
  };

  const handleSave = () => {
    try {
      // Convert array of key-value pairs back to object
      const jsonObject = {};

      // Check for duplicate keys
      const keys = jsonData.map(item => item.key);
      const hasDuplicates = keys.some((key, index) =>
        key && keys.indexOf(key) !== index
      );

      if (hasDuplicates) {
        setError("Error: Duplicate keys found. Please ensure all keys are unique.");
        return;
      }

      jsonData.forEach(pair => {
        if (pair.key.trim() !== "") {
          try {
            // Try to parse the value as JSON
            jsonObject[pair.key] = JSON.parse(pair.value);
          } catch (e) {
            // If parsing fails, use the raw string value
            jsonObject[pair.key] = pair.value;
          }
        }
      });

      // Convert to JSON string and save
      const jsonString = JSON.stringify(jsonObject, null, 2);
      onSave(jsonString);
      onClose();
    } catch (err) {
      setError(`Error saving JSON: ${err.message}`);
    }
  };



  if (!show) return null;

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content d-flex flex-column" style={{ maxHeight: "90vh" }}>
          {/* Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title">
              Edit JSON for {item.settingname || item.MQTTSettingname}
            </h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>

          {/* Modal Body */}
          <div className="modal-body" style={{ flex: '1 1 auto', overflowY: 'auto' }}>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "40%" }}>Key</th>
                    <th style={{ width: "50%" }}>Value</th>
                    <th style={{ width: "10%" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {jsonData.map((pair, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={pair.key}
                          onChange={(e) => handleKeyChange(index, e.target.value)}
                          placeholder="Property name"
                        />
                      </td>
                      <td>
                        <textarea
                          className="form-control"
                          value={pair.value}
                          onChange={(e) => handleValueChange(index, e.target.value)}
                          placeholder="Value (string, number, object, array)"
                          rows="2"
                        />
                      </td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => removeRow(index)}
                          title="Remove row"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="btn btn-info btn-sm" onClick={addRow}>
              <i className="fas fa-plus"></i> Add Property
            </button>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={() => handleSave()}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const JsonViewMode = ({ show, onClose, item }) => {
  // If the modal shouldn't be shown, return null
  if (!show) return null;

  // Function to format JSON nicely
  const formatJson = (jsonString) => {
    try {
      // Parse the JSON string and then stringify it with indentation
      const parsedJson = JSON.parse(jsonString);
      return JSON.stringify(parsedJson, null, 2);
    } catch (error) {
      return "Invalid JSON format";
    }
  };

  return (
    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">View JSON for {item.settingname || item.MQTTSettingname}</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            <pre style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "4px",
              maxHeight: "500px",
              overflow: "auto"
            }}>
              {item && item.json ? formatJson(item.json) : "No JSON data available"}
            </pre>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};


// Main MQTTSetting Component
const SerialnoMQTTSetting = () => {
  const [data, setData] = useState([]);
  const [MQTTSettingId, setMQTTSettingId] = useState([]);
  const [dataLimit] = useState(100);
  const [count] = useState(0);
  const [from] = useState(0);
  const [to] = useState(0);
  const [activeStatus] = useState("");
  const [message, setMessage] = useState("");
  const [publishInfo, setPublishInfo] = useState({});
  const [copySuccess, setCopySuccess] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [jsonModalOpen, setJsonModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [copied, setCopied] = useState(false);
  const [jsonViewModalOpen, setJsonViewModalOpen] = useState(false); // Renamed for clarity
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(null);
  const fileInputRef = useRef(null);
  const [publishKeyModalOpen, setPublishKeyModalOpen] = useState(false);
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();
  const token = getCookie("token");
  const userid = getCookie("userid");
  const [publishKeyLoading, setPublishKeyLoading] = useState(true);
  const handlePublishKey = () => {
    setPublishKeyModalOpen(true);
  };
  const handleClosePublishKeyModal = () => {
    setPublishKeyModalOpen(false);
  };
  // This could replace or supplement the useEffect that opens the modal
  useEffect(() => {
    const fetchPublishKey = async () => {
      setPublishKeyLoading(true);
      try {
        const response = await fetch('https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/SubUser/PublishId', {
          method: 'GET',
          headers: {
            'accept': 'text/plain',
            'UserId': userid || '1',
            'X-Authorization': token,
          }
        });

        const data = await response.json();
        if (data && data.isresponse && data.value) {
          setResponse(data);
        } else {
          console.error('API returned invalid response:', data);
          setMessage('Failed to load publish key. Please try again.');
        }
      } catch (error) {
        console.error('Error fetching publish key:', error);
        setMessage('Error loading publish key. Please try again.');
      } finally {
        setPublishKeyLoading(false);
      }
    };

    fetchPublishKey();
  }, [token, userid]);
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setCopySuccess(false);
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const fetchMQTTSettingData = async () => {

    try {
      // API endpoint
      const apiUrl = 'https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/SubUser/Search';

      // Headers
      const headers = {
        'accept': 'text/plain',
        'UserId': '1',
        'X-Authorization': token,
        'Content-Type': 'application/json-patch+json'
      };

      // Request body
      const requestBody = {
        "id": 0,
        "applycreateddate": false,
        "fromcreateddate": 0,
        "endcreateddate": 0,
        "active": "",
        "settingname": "",
        "ispageload": false,
        "pagesize": 1000,
        "currentpageno": 0,
        "withoutpagination": false,
        "pagedirection": "first"
      };
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestBody)
      });

      // Parse the response
      const responseData = await response.json();

      // Transform the data to match the expected format in your table
      if (responseData && Array.isArray(responseData.data)) {
        // Map the API response to match your table's expected format
        const transformedData = responseData.data.map(item => ({
          ...item,
          MQTTSettingname: item.settingname, // Add MQTTSettingname property based on settingname
          publishId: item.publishid // Adjust case for publishId if needed
        }));

        setData(transformedData);
        return transformedData;
      } else {
        setData([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching MQTT Setting data:", error);
      setMessage("Failed to load data. Please try again.");
      setData([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchMQTTSettingDataForId = async () => {
    try {
      const MQTTSettingGetDistinct = getUrlByOperation("MQTTSettingGetDistinct");
      const response = await fetch(`${MQTTSettingGetDistinct}/MQTTSettingname`, {
        headers: {
          accept: "text/plain",
          "X-Authorization": token,
          UserId: userid,
        },
      });

      const responseData = await response.json();
      if (responseData && Array.isArray(responseData.data)) {
        setMQTTSettingId(responseData.data);
      } else {
        setMQTTSettingId([]);
      }
    } catch (error) {
      console.error("Error fetching MQTTSetting IDs:", error);
    }
  };

  useEffect(() => {
    // Call it once immediately
    fetchMQTTSettingData();
    fetchMQTTSettingDataForId();

    // Set interval to call fetchMQTTSettingData every 5 seconds
    const interval = setInterval(() => {
      fetchMQTTSettingData();
    }, 5000); // 5000 ms = 5 seconds

    // Clear interval on component unmount or when dependencies change
    return () => clearInterval(interval);
  }, [getUrlByOperation, token, userid, dataLimit, count, from, to, activeStatus]);


  // Clean up message after display
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setCopySuccess(false);
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleAddPop = () => {
    navigate("/addSerialnoMqttSetting");
  };

  const handleUpdatePop = (id, deviceId) => {
    navigate(`/updateSerialnoMqttSetting/${id}/${deviceId}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      return;
    }

    try {
      const response = await fetch('https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/SubUser/Delete', {
        method: 'POST',
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
        body: JSON.stringify({ id }),
      });

      if (response.ok) {
        setMessage("Data deleted successfully!");
        setCopySuccess(true);
        fetchMQTTSettingData(); // Refresh data after delete
      } else {
        throw new Error("Failed to delete data");
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data");
    }
  };

  const handleToggle = async (item) => {
    const apiUrl = item.active ? getUrlByOperation("serialNoMQTTSettingDeactive") : getUrlByOperation("serialNoMQTTSettingActive");

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      if (response.ok) {
        setData(data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d)));
        setMessage(`Your Status Updated  successfully!`);
        setCopySuccess(true);
      } else {
        throw new Error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setMessage("Failed to update status");
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };
  const handleTogglelockkey = async (item) => {
    const apiUrl = item.lockkey ? getUrlByOperation("serialNoMQTTSettingDeactiveLockkey") : getUrlByOperation("serialNoMQTTSettingActiveLockkey");

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
        body: JSON.stringify({ id: item.id }),
      });

      if (response.ok) {
        setData(data.map((d) => (d.id === item.id ? { ...d, lockkey: !item.lockkey } : d)));
        setMessage(`Your Status Updated  successfully!`);
        setCopySuccess(true);
      } else {
        throw new Error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setMessage("Failed to update status");
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  // Modified handleCopyHttp function with null check
  const handleCopyHttp = (key) => {
    if (!response || !response.value) {
      setMessage("Publish key not available yet. Please try again in a moment.");
      return;
    }

    const urlToCopy = `http://api.dqr-display-tms.eventum.co.in/api/Share/SubUser/DeviceJsonSetting/File/${response.value}/${key}`;
    copyToClipboard(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        setMessage("Failed to copy URL");
      });
  };

  // Modified handleCopyHttps function with null check
  const handleCopyHttps = (key) => {
    if (!response || !response.value) {
      setMessage("Publish key not available yet. Please try again in a moment.");
      return;
    }

    const urlToCopy = `https://api.dqr-display-tms.eventum.co.in/api/Share/SubUser/DeviceJsonSetting/File/${response.value}/${key}`;
    copyToClipboard(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        setMessage("Failed to copy URL");
      });
  };

  // Modified handleCopyJsonHttp function with null check
  const handleCopyJsonHttp = (key) => {
    if (!response || !response.value) {
      setMessage("Publish key not available yet. Please try again in a moment.");
      return;
    }

    const urlToCopy = `http://api.dqr-display-tms.eventum.co.in/api/Share/SubUser/DeviceJsonSetting/Json/${response.value}/${key}`;
    copyToClipboard(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        setMessage("Failed to copy URL");
      });
  };

  // Modified handleCopyJsonHttps function with null check
  const handleCopyJsonHttps = (key) => {
    if (!response || !response.value) {
      setMessage("Publish key not available yet. Please try again in a moment.");
      return;
    }

    const urlToCopy = `https://api.dqr-display-tms.eventum.co.in/api/Share/SubUser/DeviceJsonSetting/Json/${response.value}/${key}`;
    copyToClipboard(urlToCopy)
      .then(() => {
        setCopied(true);
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        setMessage("Failed to copy URL");
      });
  };

  function copyToClipboard(text) {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text)
        .then(() => true)
        .catch(err => {
          console.error('Could not copy text using Clipboard API: ', err);
          return fallbackCopyToClipboard(text);
        });
    } else {
      return Promise.resolve(fallbackCopyToClipboard(text));
    }
  }

  function fallbackCopyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    let success = false;
    try {
      success = document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy with fallback method:', err);
    }

    document.body.removeChild(textArea);
    return success;
  }

  const handlePublish = async (id) => {
    setPublishLoading(true);
    try {
      const response = await fetch(
        'https://api.dqr-display-tms.eventum.co.in/api/JsonSettingOperation/SubUser/Generate/PublishId',
        {
          method: 'POST',
          headers: {
            'accept': 'text/plain',
            'UserId': userid || '1',
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          },
          body: JSON.stringify({ id })
        }
      );

      const responseData = await response.json();

      if (responseData && responseData.isresponse) {
        const publishId = responseData.publishid || "";

        const publishUrl = `${window.location.origin}/MQTTSettingpreview-publish/${publishId}`;

        setPublishInfo({
          id,
          encodedUrl: publishUrl,
          encodedId: publishId
        });

        const copied = await copyToClipboard(publishUrl);

        if (copied) {
          setMessage("URL copied to clipboard!");
          setCopySuccess(true);
        } else {
          setMessage("Generated URL: " + publishUrl);
          setCopySuccess(true);
        }

        fetchMQTTSettingData();
      } else {
        throw new Error(responseData?.errormsg || "Failed to generate publish ID");
      }
    } catch (error) {
      console.error("Error generating publish ID:", error);
      setMessage(error.message || "Failed to generate publish URL");
    } finally {
      setPublishLoading(false);
    }
  };

  const handleCopyClick = async (Id) => {
    if (!response || !response.value) {
      setMessage("Publish key not available yet. Please try again in a moment.");
      return;
    }
    const publishUrl = `${window.location.origin}/CS80/SerialnoMqttSetting/${response.value}/${Id}`;

    try {
      const copied = await copyToClipboard(publishUrl);

      if (copied) {
        setMessage("URL copied to clipboard!");
        setCopySuccess(true);
      } else {
        setMessage("URL: " + publishUrl);
        setCopySuccess(true);
      }
    } catch (error) {
      console.error("Failed to copy URL:", error);
      setMessage("Failed to copy URL to clipboard: " + publishUrl);
    }
  };

  // Function to handle opening the JSON editor modal
  const handleEditJson = (item) => {
    setCurrentItem(item);
    setJsonModalOpen(true);
  };

  const handleViewPOP = (item) => {
    setCurrentItem(item);
    setJsonViewModalOpen(true); // Use the setter function, not the state variable
  };


  // Function to handle saving JSON from the modal
  const handleSaveJson = async (jsonString) => {
    try {
      // Validate JSON
      JSON.parse(jsonString);

      // Prepare update payload
      const updatePayload = {
        id: currentItem.id,
        active: currentItem.active,
        lockkey: currentItem.lockkey,
        remark: currentItem.remark,
        deviceid: currentItem.deviceid,
        json: jsonString
      };

      console.log("Sending payload:", updatePayload);

      // Make API call
      const response = await fetch('https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/SubUser/Update', {
        method: 'POST',
        headers: {
          'accept': 'text/plain',
          'UserId': userid || '1',
          'X-Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatePayload)
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Update successful:", result);
        setMessage("JSON updated successfully!");
        setCopySuccess(true);

        // Update frontend state
        setData(data.map(item =>
          item.id === currentItem.id
            ? { ...item, json: jsonString }
            : item
        ));
      } else {
        throw new Error("Update failed: " + await response.text());
      }
    } catch (error) {
      console.error("Error updating JSON:", error);
      setMessage("Failed to update JSON: " + error.message);
    }
  };


  // Fixed renderPublishColumn function
  const renderPublishColumn = (item) => {


    // If no publishid and not currently processing, show the publish button
    return (
      <div className="d-flex flex-column">
        <div className="mb-2">
        </div>
        <div className="btn-group">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => handleCopyClick(item.deviceid)}
            disabled={!response || !response.value}
          >
            <i className="fas fa-copy mr-1"></i> URL
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopyHttp(item.deviceid)}
            title="Copy HTTP URL"
            disabled={!response || !response.value}
          >
            File HTTP
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopyHttps(item.deviceid)}
            title="Copy HTTPS URL"
          >
            File HTTPS
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopyJsonHttp(item.deviceid)}
            title="Copy HTTP URL"
          >
            Json HTTP
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => handleCopyJsonHttps(item.deviceid)}
            title="Copy HTTPS URL"
          >
            Json HTTPS
          </button>

        </div>
      </div>
    );
  };

  // Function to render the JSON display column
  const renderJsonColumn = (item) => {
    return (
      <div className="json-preview">
        <div className="mb-2">
          {item.json ? (
            <div
              className="text-truncate"
              style={{
                maxWidth: '150px',
                maxHeight: '50px',
                overflow: 'hidden',
                padding: '4px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                border: '1px solid #dee2e6',
                fontSize: '0.8rem'
              }}
            >
              {item.json}
            </div>
          ) : (
            <span className="text-muted">Empty JSON</span>
          )}
        </div>
        <button
          type="button"
          className="btn btn-sm btn-primary ml-3"
          onClick={() => handleEditJson(item)}
        >
          <i className="fas fa-edit "></i>
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary ml-1"
          onClick={() => handleViewPOP(item)}
        >
          <i className="fas fa-eye "></i>
        </button>
      </div>
    );
  };

  useEffect(() => {
    // Call handlePublishKey once when the component mounts
    handlePublishKey();
    // Empty dependency array means this runs only once when component mounts
  }, []);

  // Handle opening the modal
  const handleUploadExcel = () => {
    setShowModal(true);
    // Reset the state when opening the modal
    setSelectedFile(null);
    setUploadStatus(null);
    setUploadProgress(0);
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate if it's an Excel file
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');

      if (isExcel) {
        setSelectedFile(file);
        setUploadStatus(null);
      } else {
        setSelectedFile(null);
        setUploadStatus({
          type: 'error',
          message: 'Please select a valid Excel file (.xlsx, .xls)'
        });
      }
    }
  };

  // Handle file upload
  const handleUploadFile = async () => {
    if (!selectedFile) {
      setUploadStatus({
        type: 'error',
        message: 'Please select a file first'
      });
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      setUploadStatus({
        type: 'error',
        message: 'Authentication error. Please log in again.'
      });
      return;
    }

    setUploading(true);
    setUploadProgress(0);

    // Create FormData
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/SubUser/Upload',
        formData,
        {
          headers: {
            'X-Authorization': token,
            'UserId': userid,
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted);
          }
        }
      );

      // Handle the response
      if (response.data && response.data.isresponse && response.data.responsestatus === "SUCCESS") {
        setUploadStatus({
          type: 'success',
          message: 'File uploaded successfully!'
        });

        // Close the modal after a successful upload (with a slight delay)
        setTimeout(() => {
          setShowModal(false);
          // Optionally refresh the page or trigger another function
          // window.location.reload();
        }, 2000);
      } else {
        setUploadStatus({
          type: 'error',
          message: `Upload failed: ${response.data?.errormsg || 'Unknown error'}`
        });
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadStatus({
        type: 'error',
        message: `Upload failed: ${error.response?.data?.errormsg || error.message || 'Server error'}`
      });
    } finally {
      setUploading(false);
    }
  };

  // Handle drag and drop functionality
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];

      // Check if it's an Excel file
      const isExcel =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');

      if (isExcel) {
        setSelectedFile(file);
        setUploadStatus(null);
      } else {
        setUploadStatus({
          type: 'error',
          message: 'Please drop a valid Excel file (.xlsx, .xls)'
        });
      }
    }
  };

  // Trigger file input click
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="mb-0">Serial No Mqtt Settings</h1>

                    <div className="d-flex align-items-center">
                      {/* Publish Key Modal and loading indicator */}
                      <div className="mr-2">
                        <PublishKeyModal
                          show={publishKeyModalOpen}
                          onClose={handleClosePublishKeyModal}
                          token={token}
                          userid={userid}
                          onKeyLoaded={(keyData) => {
                            setResponse(keyData);
                            setPublishKeyLoading(false);
                          }}
                        />
                        {publishKeyLoading && (
                          <small className="text-muted d-block">
                            <i className="fas fa-spinner fa-spin mr-1"></i> Loading publish key...
                          </small>
                        )}
                      </div>

                      {/* Upload Excel button */}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleUploadExcel}
                      >
                        <i className="fas fa-file-excel mr-1"></i>
                        Upload Excel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Json Settings List</h3>
                </div>
                <div className="card-body p-0">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2">Loading settings...</p>
                    </div>
                  ) : data.length === 0 ? (
                    <div className="text-center py-5">
                      <p>No MQTT settings found.</p>
                      <button className="btn btn-primary" onClick={handleAddPop}>
                        <i className="fas fa-plus mr-1"></i> Add Json Setting
                      </button>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>ID</th>
                            {/* <th>Setting Name</th> */}
                            {/* <th>Remark</th> */}
                            <th>Device Id</th>
                            <th>Status</th>
                            <th>JSON</th>
                            <th>Lockkey Status</th>
                            <th>Publish</th>
                            <th>Actions</th>

                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index}>
                              <td>{item.id}</td>
                              <td>{item.deviceid}</td>

                              <td>
                                <div className="custom-control custom-switch">
                                  <Switch
                                    isOn={item.active}
                                    handleToggle={() => handleToggle(item)}
                                    id={`switch-${item.id}`}
                                  />
                                  {/* <span className="ml-2">{item.active ? "Active" : "Inactive"}</span> */}
                                </div>
                              </td>
                              <td>{renderJsonColumn(item)}</td>
                              <Switch
                                isOn={item.lockkey}
                                handleToggle={() => handleTogglelockkey(item)}
                                id={`switch-${item.id}`}
                              />
                              <td>{renderPublishColumn(item)}</td>
                              <td>
                                <div className="btn-group">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-info "
                                    onClick={() => handleUpdatePop(item.id, item.deviceid)}
                                    title="Update"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger ml-3"
                                    onClick={() => handleDelete(item.id)}
                                    title="Delete"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* JSON Editor Modal */}
      <JsonEditorModal
        show={jsonModalOpen}
        onClose={() => setJsonModalOpen(false)}
        item={currentItem || {}}
        onSave={handleSaveJson}
      />

      {/* JSON View Modal - Fixed component usage */}
      <JsonViewMode
        show={jsonViewModalOpen}
        onClose={() => setJsonViewModalOpen(false)}
        item={currentItem || {}}
      />

      {/* Toast notifications */}
      {message && (
        <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: "9999" }}>
          <div
            className={`toast show ${copySuccess ? "bg-success" : "bg-danger"}`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="toast-header">
              {/* <strong className="mr-auto">{copySuccess ? " URL copied to clipboard!" : "Error"}</strong> */}
              <button
                type="button"
                className="ml-2 mb-1 close"
                onClick={() => setMessage("")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {/* <div className="toast-body text-white">
              {message}
            </div> */}
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload Excel File</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => !uploading && setShowModal(false)}
                  disabled={uploading}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
                {/* File input (hidden) */}
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                  accept=".xlsx,.xls"
                />

                {/* Drag and drop area */}
                <div
                  className="border border-dashed rounded p-4 text-center bg-light cursor-pointer"
                  style={{
                    borderStyle: 'dashed',
                    borderWidth: '2px',
                    borderColor: '#ccc',
                    cursor: 'pointer'
                  }}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onClick={triggerFileInput}
                >
                  <i className="fas fa-file-excel fa-3x mb-3 text-primary"></i>
                  <p>Drag and drop your Excel file here, or click to browse</p>
                  <p className="text-muted small">Supported formats: .xlsx, .xls</p>
                </div>

                {/* Selected file info */}
                {selectedFile && (
                  <div className="mt-3 p-2 bg-light rounded">
                    <div className="d-flex align-items-center">
                      <i className="fas fa-file-excel text-primary mr-2"></i>
                      <div className="text-truncate">
                        <strong>Selected file:</strong> {selectedFile.name}
                      </div>
                    </div>
                    <div className="text-muted small">
                      Size: {(selectedFile.size / 1024).toFixed(2)} KB
                    </div>
                  </div>
                )}

                {/* Upload progress */}
                {uploading && (
                  <div className="mt-3">
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${uploadProgress}%` }}
                        aria-valuenow={uploadProgress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {uploadProgress}%
                      </div>
                    </div>
                  </div>
                )}

                {/* Status messages */}
                {uploadStatus && (
                  <div className={`mt-3 alert alert-${uploadStatus.type === 'success' ? 'success' : 'danger'}`}>
                    {uploadStatus.message}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={uploading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUploadFile}
                  disabled={!selectedFile || uploading}
                >
                  {uploading ? 'Uploading...' : 'Upload'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {/* Keep the original message components for compatibility */}
      {message === "URL copied to clipboard!" && <SuccessMessage message={message} />}
      {message === "Data deleted successfully!" && <SuccessMessage message={message} />}
      {message === "Failed to delete data" && <FailedMessage message={message} />}
      {message === "Key published and copied to clipboard!" && <SuccessMessage message={message} />}
      {message === "Your Status Updated  successfully!" && <SuccessMessage message={message} />}
    </>
  );
};

export default SerialnoMQTTSetting;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}